var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4004 0H1.70893C0.796874 0 0 0.65625 0 1.55759V18.2862C0 19.1924 0.796874 20 1.70893 20H18.3955C19.3125 20 20 19.1871 20 18.2862V1.55759C20.0053 0.65625 19.3125 0 18.4004 0ZM6.19954 16.671H3.33437V7.7625H6.19954V16.671ZM4.86606 6.40804H4.84553C3.92857 6.40804 3.33482 5.72545 3.33482 4.87098C3.33482 4.00089 3.94419 3.33438 4.88169 3.33438C5.81919 3.33438 6.39285 3.99598 6.41338 4.87098C6.41294 5.72545 5.81919 6.40804 4.86606 6.40804ZM16.671 16.671H13.8058V11.8C13.8058 10.633 13.3888 9.83572 12.3522 9.83572C11.5603 9.83572 11.0915 10.3714 10.883 10.8933C10.8049 11.0808 10.7839 11.3362 10.7839 11.5969V16.671H7.91874V7.7625H10.7839V9.00223C11.2009 8.40848 11.8522 7.55402 13.3678 7.55402C15.2486 7.55402 16.6714 8.79375 16.6714 11.4665L16.671 16.671Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightLinkedin);
export default __webpack_public_path__ + "static/media/lightLinkedin.d081040a6621a581754d117291434f8f.svg";
export { ForwardRef as ReactComponent };